import React, { Component } from 'react'
import { connect } from 'react-redux';

import { dataType } from '@/constants/data-type';

import '../../../assets/styles/components/detail-center/summary.scss'   //scss

import { getSafe } from '@/helpers/global'; // 判断值是否为空的工具
import LoadingLayer from '@/components/Spinner/LoadingLayer'; //加载组件

import DataTable from '@/components/DataTable/DataTable';
// 请求相关
import { utilsFunction, Converter } from '@/helpers/functions';
import { ACTION_TYPE } from "@/constants/w-socket";
import { WS_LANG_KEY } from "@/constants/app";
import { stockActions } from "@/actions/trading/stock.action";



class Summary extends Component {
    constructor(props) {
        super(props)
        this.state = {
            columnDefs: [
                {
                    headerName: props.language.market_d_a_i_s_s,
                    colId: 'market_d_a_i_s_s',
                    field: 'd_a_i_s_s',
                    headerClass: 'table-header',
                    cellClass: 'table-cell',
                    dataType: dataType.TEXT
                },
                {
                    headerName: props.language.market_l_the_total_equity,
                    colId: 'market_l_the_total_equity',
                    field: 'l_the_total_equity',
                    headerClass: 'table-header',
                    cellClass: 'table-cell',
                    dataType: dataType.TEXT
                },
                {
                    headerName: props.language.market_r_the_total_equity,
                    colId: 'market_r_the_total_equity',
                    field: 'r_the_total_equity',
                    headerClass: 'table-header',
                    cellClass: 'table-cell',
                    dataType: dataType.TEXT
                },
            ],
            dividendColDef: [
                {
                    headerName: props.language.market_allocation_scheme,
                    colId: 'market_allocation_scheme',
                    field: 'type',
                    headerClass: 'table-header',
                    cellClass: 'table-cell',
                    dataType: dataType.TEXT
                },
                {
                    headerName: props.language.common_content,
                    colId: 'common_content',
                    field: 'content',
                    headerClass: 'table-header',
                    cellClass: 'table-cell',
                    dataType: dataType.TEXT
                },
                {
                    headerName: props.language.market_ex_dividend_date,
                    colId: 'market_ex_dividend_date',
                    field: 'clearDate',
                    headerClass: 'table-header',
                    cellClass: 'table-cell',
                    dataType: dataType.SHORT_DATE
                },
                {
                    headerName: props.language.market_dividend_day,
                    colId: 'market_dividend_day',
                    field: 'dividendDate',
                    headerClass: 'table-header',
                    cellClass: 'table-cell',
                    dataType: dataType.SHORT_DATE
                }
            ],
            mainIndexData: {},
            industryData: {},
            companyInfoData: {},
            unFold: false,
            foldTips: true,
            MainLoad: true,
            IndustryLoad: true,
            AbstractLoad: true,
            ExecutivesLoad: true,
            ChangeLoad: false,
            marketID: '',
            InstrumentID: '',
            ShareholderData: null,
            ExecutivesData: null,
            dividendData: [],
            // dividendData: 
            // [
            //     {type:'Final',content:"D: HKD 0.0100",dividendDate:1120780800000,clearDate:1116460800000},
            //     {type:'Final',content:"D: HKD 0.0100",dividendDate:1120780800000,clearDate:1116460800000},
            //     {type:'Final',content:"D: HKD 0.0100",dividendDate:1120780800000,clearDate:1116460800000},
            //     {type:'Final',content:"D: HKD 0.0100",dividendDate:1120780800000,clearDate:1116460800000},
            //     {type:'Final',content:"D: HKD 0.0100",dividendDate:1120780800000,clearDate:1116460800000},
            //     {type:'Final',content:"D: HKD 0.0100",dividendDate:1120780800000,clearDate:1116460800000},
            //     {type:'Final',content:"D: HKD 0.0100",dividendDate:1120780800000,clearDate:1116460800000},
            //     {type:'Final',content:"D: HKD 0.0100",dividendDate:1120780800000,clearDate:1116460800000},
            //     {type:'Final',content:"D: HKD 0.0100",dividendDate:1120780800000,clearDate:1116460800000},
            //     {type:'Final',content:"D: HKD 0.0100",dividendDate:1120780800000,clearDate:1116460800000},
            //     {type:'Final',content:"D: HKD 0.0100",dividendDate:1120780800000,clearDate:1116460800000},
            //     {type:'Final',content:"D: HKD 0.0100",dividendDate:1120780800000,clearDate:1116460800000},
            //     {type:'Final',content:"D: HKD 0.0100",dividendDate:1120780800000,clearDate:1116460800000},
            // ],

        }
    }
    render() {
        const { language, autoSize } = this.props;
        const { companyInfoData, unFold, foldTips, MainLoad, mainIndexData, industryData,columnDefs, ShareholderData, ExecutivesData, dividendData, dividendColDef  } = this.state
        return (
        <div className='summary-body' >
            <div className='summary'>
                {/* main-index         */}
                <LoadingLayer load={MainLoad} />
                <div className='main-index'>
                    <table >
                        <thead >
                            <tr>
                                <th style={{ textAlign: 'left'}}>{language.market_main_indicator}</th>
                            </tr>
                        </thead>
                        <tbody >
                            <tr>
                                <td>{language.market_p_e}</td>
                                <td style={{ textAlign: 'right', color: '#fff' }}>{mainIndexData.PE ? mainIndexData.PE : '-'}</td>
                            </tr>
                            <tr>
                                <td>{language.market_eps}</td>
                                <td style={{ textAlign: 'right' }}>{mainIndexData.EPS ? mainIndexData.EPS : '-'}</td>
                            </tr>
                            <tr>
                                <td>{language.market_revenue}</td>
                                <td style={{ textAlign: 'right' }}>{mainIndexData.Revenue ? mainIndexData.Revenue : '-'}</td>
                            </tr>
                            <tr>
                                <td>{language.market_net_profit}</td>
                                <td style={{ textAlign: 'right' }}>{mainIndexData.NetProfit ? mainIndexData.NetProfit : '-'}</td>
                            </tr>
                        </tbody>
                    </table>
                    <table>
                        <thead >
                            <tr>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody >
                            <tr>
                                <td>{language.market_quote_shares}</td>
                                <td style={{ textAlign: 'right' }}>{mainIndexData.Shares ? mainIndexData.Shares : '-'}</td>
                            </tr>
                            <tr>
                                <td>{language.market_h_shares}</td>
                                <td style={{ textAlign: 'right' }}>{mainIndexData.HShares ? mainIndexData.HShares : "-"}</td>
                            </tr>
                            <tr>
                                <td>{language.market_quote_pb}</td>
                                <td style={{ textAlign: 'right' }}>{mainIndexData.PB ? mainIndexData.PB : '-'}</td>
                            </tr>
                            <tr>
                                <td>{language.market_pen}</td>
                                <td style={{ textAlign: 'right' }}>{mainIndexData.PNE ? mainIndexData.PNE : '-'}</td>
                            </tr>
                        </tbody>
                    </table>
                    <table>
                        <thead >
                            <tr>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody >
                            <tr>
                                <td>{language.market_div_yield}</td>
                                <td style={{ textAlign: 'right' }}>{mainIndexData.DivYield ? mainIndexData.DivYield : '-'}</td>
                            </tr>
                            <tr>
                                <td>{language.market_revenue_form}</td>
                                <td style={{ textAlign: 'right' }}>{mainIndexData.RevenueFrom ? mainIndexData.RevenueFrom : '-'}</td>
                            </tr>
                            <tr>
                                <td style={{ minWidth: '120px' }}>{language.market_cap}</td>
                                <td style={{ textAlign: 'right' }}>{mainIndexData.MarketCap ? mainIndexData.MarketCap : '-'}</td>
                            </tr>
                            <tr>
                                <td style={{ minWidth: '120px' }}>{language.market_h_mkt_cap}</td>
                                <td style={{ textAlign: 'right' }}>{mainIndexData.HMktCap ? mainIndexData.HMktCap : '-'}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                {/* industry            */}
                <div className='industry'>
                    <table>
                        <thead>
                            <tr>
                                <th style={{ textAlign: 'left' }}>{language.market_industry}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{minWidth:'200px'}}>{industryData.sector}</td>
                                <td style={{ color: '#2a7b56' }}>{'-'}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                {/* Abstract of Company */}
                <div className='abstract'>
                    <h4>{language.market_abstract_of_company}</h4>
                    <div className="infor-item">
                        <label>{getSafe(() => language.common_companyName)}</label>
                        <span>{companyInfoData ? (companyInfoData.basicInfo ? (companyInfoData.basicInfo.companyName ? companyInfoData.basicInfo.companyName : '-') : '-') : '-'}</span>
                    </div>
                    <div className="infor-item">
                        <label>{getSafe(() => language.common_chairman)}</label>
                        <span>{companyInfoData ? (companyInfoData.basicInfo ? (companyInfoData.basicInfo.chairperson ? companyInfoData.basicInfo.chairperson : '-') : '-') : '-'}</span>
                    </div>
                    <div className="infor-item">
                        <label>{getSafe(() => language.common_listingDate)}</label>
                        <span>{companyInfoData ? (companyInfoData.basicInfo ? (companyInfoData.basicInfo.listingDate ? companyInfoData.basicInfo.listingDate : '-') : '-') : '-'}</span>
                    </div>
                    <div className="infor-item">
                        <label>{getSafe(() => language.common_initialPrice)}</label>
                        <span>{companyInfoData ? (companyInfoData.basicInfo ? (companyInfoData.basicInfo.issuePrice ? companyInfoData.basicInfo.issuePrice : '-') : '-') : '-'}</span>
                    </div>
                    <div className="infor-item">
                        <label>{getSafe(() => language.market_shares_offered)}</label>
                        <span>{'-'}</span>
                    </div>
                    <div className="infor-item" >
                        <label>{getSafe(() => language.common_business)}</label>
                        <span ref={this.foldRef} className={unFold ? "" : "overflow-text"} dangerouslySetInnerHTML={{ __html: (companyInfoData ? (companyInfoData.basicInfo ? (companyInfoData.basicInfo.business ? companyInfoData.basicInfo.business : '-') : '-') : '-') }}>
                            { }
                        </span>
                        {
                            foldTips &&
                            <div className='unfold-action' onClick={() => this.setState({ unFold: !this.state.unFold })}>
                                {unFold ? getSafe(() => language.market_fold) : getSafe(() => language.market_unfold)}
                            </div>
                        }
                    </div>
                </div>
                {/* Shareholder Structure */}
                <div className='shareholder' >
                    <h4>{language.market_shaerholder_structure}</h4>
                    <div  style={{ width:'99% ',  height: (ShareholderData?.length)  ? (ShareholderData.length == 1) ? '59px' : ((ShareholderData.length ) * 27.4  + 30 ) : '180px'}} >
                        <DataTable
                        showPagination={false}
                        columnDefs={columnDefs}
                        innerRef={e => this.ShareholderRef = e}
                        data={ShareholderData} 
                        />
                    </div>
                    
                </div>
                {/* Company Executives */}
                <div className='Executives'>
                    <h4>{language.market_company_executives}</h4>
                    <table>
                        <thead>
                            <tr>
                                <td>{language.market_executives}</td>
                                <td style={{ textAlign: 'left' }}>{language.market_position}</td>
                            </tr>
                        </thead>
                        <tbody>
                            {ExecutivesData && (ExecutivesData.data).map((item, index) => {
                                return (
                                    <tr key={index} style={{ paddingBottom: '20px' }}>
                                        <td>{item[0]}</td>
                                        <td style={{ textAlign: 'left' }}>{item[1]}</td>
                                    </tr>
                                )
                            })}
                            {!ExecutivesData &&
                                <tr>
                                    <td> - </td>
                                    <td> - </td>
                                </tr>

                            }
                        </tbody>
                    </table>
                </div>
                {/* Changes in Ownership */}
                {/* <div className='change'>
                    <h4>{language.market_changes_in_ownership}</h4>
                    <table >
                        <thead>
                            <tr>
                                <td>{language.market_change_time}</td>
                                <td>{language.market_shaers_changed}</td>
                                <td style={{minWidth :'180px'}}>{language.market_shareholding_after_change}</td>
                                <td>{language.market_nature}</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Blackrock,inc</td>
                                <td rowSpan='2' ><div style={{ marginTop: '-15px' }}>-141M</div></td>
                                <td>5.896B</td>
                                <td rowSpan='2'><div style={{ marginTop: '-15px' }}>Long</div></td>
                            </tr>
                            <tr>
                                <td style={{ color: '#a7a7a7', fontSize: '10px', }}><div style={{ marginTop: '-18px' }}>2019-08-05</div></td>
                                <td style={{ color: '#a7a7a7', fontSize: '10px', }}><div style={{ marginTop: '-18px' }}>6.59%</div></td>
                            </tr>
                            <tr>
                                <td>Blackrock,inc</td>
                                <td rowSpan='2' ><div style={{ marginTop: '-15px' }}>-141M</div></td>
                                <td>5.896B</td>
                                <td rowSpan='2'><div style={{ marginTop: '-15px' }}>Long</div></td>
                            </tr>
                            <tr>
                                <td style={{ color: '#a7a7a7', fontSize: '10px', }}><div style={{ marginTop: '-18px' }}>2019-08-05</div></td>
                                <td style={{ color: '#a7a7a7', fontSize: '10px', }}><div style={{ marginTop: '-18px' }}>6.59%</div></td>
                            </tr>
                        </tbody>
                    </table>
                </div> */}
                {/* Dividens */}
                <div className='dividens' >
                    <h4>{language.market_dividends}</h4>
                    <div  style={{width:"99%", height: dividendData?.length ? dividendData.length == 1 ? "59px" :  dividendData.length * 26.1  + 30 : "180px"}}>
                         <DataTable
                        showPagination={false}
                        columnDefs={dividendColDef}
                        innerRef={e => this.dividendRef = e}
                        data={dividendData} 
                        />
                    </div>
                   
                </div>
                {/* Disclaimer */}
                <div className='disclaimer' dangerouslySetInnerHTML={{ __html: language.market_summary_disclaimer }} />
            </div>
        </div>
            
        )
    }
    componentDidMount() {
        this.props.innerRef(this)
        const { marketParams } = this.props;
        const { marketID, stockCode } = marketParams;
        this.setState({
            marketID: marketID,
            InstrumentID: stockCode
        }, () => {
            this.getCompanyProfile()
            this.getMainIndex()
            this.getDividends()
        })
    }
    componentDidUpdate(preProps) {
        const { currentTradingAccount, isNeedRefresh, language, mdsToken  , marketParams} = this.props
        const { marketID, stockCode } = marketParams;
        if (language && preProps.language !== language) {
            this.getMainIndex()
            this.getCompanyProfile()
            this.getDividends()
        }
        if(marketParams && preProps.marketParams !== marketParams){
            this.setState({ 
            marketID: marketID,
            InstrumentID: stockCode,
        },()=>{
            this.getMainIndex()
            this.getCompanyProfile()
            this.getDividends()
            })
        }
        
    }
 
    NumericalTransformation(num) {  
        if(num){
       const language = utilsFunction.switchToolTipsLanguage(this.props.language, WS_LANG_KEY.EN, WS_LANG_KEY.SC, WS_LANG_KEY.TC)
       let negative = ''
       if(num.includes('-')){  
            negative = '-'
           num = num.substr(1,(num.length + 1))
       }
       if (language == 'en') {     
           if (num.length >= 10) {    
               if((num / 1000000000).toString().includes('.')){
                   return negative + (num / 1000000000).toString().split('.')[0] + '.' + (num / 1000000000).toString().split('.')[1].substr(0, 3) + 'B'
               }else {
                   return negative + (num / 1000000000) + 'B'
               }
           }else if (num.length >= 7) {
               if((num / 1000000).toString().includes('.')){
                   return negative + (num / 1000000).toString().split('.')[0] + '.' + (num / 1000000).toString().split('.')[1].substr(0, 3) + 'M'
               }else {
                   return negative + (num / 1000000) + 'M'
               }
           } else return negative + num
       } else {
           if (num.length >= 9) {   
               if((num / 100000000).toString().includes('.')){
                   return  negative + (num / 100000000).toString().split('.')[0] + '.' + (num / 100000000).toString().split('.')[1].substr(0, 2) + '亿'
               } else {
                   return negative + (num / 100000000) + '亿'
               }
           } else if (num.length >= 5) {
               if((num / 10000).toString().includes('.')){
                   return negative + (num / 10000).toString().split('.')[0] + '.' + (num / 10000).toString().split('.')[1].substr(0, 2) + '万'
               }else {
                 return negative +  (num / 10000) + '万'
               }
           } else return negative + num
       }
     }
   }
 
    Decimal(num, x, Percentage = false) {
        let placeholder = ' '
        if (Percentage) placeholder = '%'
        else placeholder = ' '
        return num.split('.')[0] + '.' + num.split('.')[1].substr(0, x) + placeholder
    }

    getMainIndex() {
        let { marketID, InstrumentID } = this.state
        marketID = Converter.mappingWebSocketMarket(marketID);
        let stockID = InstrumentID
        if(!stockID){
            this.setState({MainLoad:false,IndustryLoad:false})
            return 
        }
        stockID = this.state.InstrumentID.split('').findIndex(i => i !== '0')
        if (stockID > -1) {
            stockID = this.state.InstrumentID.substr(stockID)
        }
        const params = {
            msgType: ACTION_TYPE.SECURITY_FINANCIAL_DATA,
            symbol: { exchangeID: marketID, key: stockID },
            language: utilsFunction.switchToolTipsLanguage(this.props.language, WS_LANG_KEY.EN, WS_LANG_KEY.SC, WS_LANG_KEY.TC)
        }
        this.setState({ MainLoad: true, IndustryLoad: true })
        this.props.getFinancial(params, financialres => {
            const mainIndexData = {}
            const industryData = {}
            if (financialres) {
                mainIndexData.Shares = financialres.totalCapital && this.NumericalTransformation(financialres.totalCapital)
                mainIndexData.HShares = financialres.circCapital && this.NumericalTransformation(financialres.circCapital)
                mainIndexData.Revenue = financialres.operProfit && this.NumericalTransformation(financialres.operProfit)
                mainIndexData.NetProfit = financialres.netProfit && this.NumericalTransformation(financialres.netProfit)
                mainIndexData.MarketCap = financialres.marketCap && this.NumericalTransformation(financialres.marketCap)
                mainIndexData.HMktCap = financialres.cirMarketCap && this.NumericalTransformation(financialres.cirMarketCap)
                mainIndexData.PE = financialres.peRatio && this.Decimal(financialres.peRatio, 2)
                mainIndexData.EPS = financialres.earnps && this.Decimal(financialres.earnps, 2)
                mainIndexData.PB = financialres.pbRatio && this.Decimal(financialres.pbRatio, 2)
                mainIndexData.PNE = financialres.netAssetps && this.Decimal(financialres.netAssetps, 2)
                mainIndexData.DivYield = financialres.yield && this.Decimal(financialres.yield, 2, true)
                mainIndexData.RevenueFrom = financialres.operProfitGrow && this.Decimal(financialres.operProfitGrow, 2, true)
                industryData.sector = financialres.sector
            }
            this.setState({ mainIndexData, industryData ,MainLoad: false, }, () => {
            })
        })
    }
    getCompanyProfile() {
        this.setState({companyInfoData:null,ShareholderData:null,ExecutivesData:null})
        this.ShareholderRef.toggleLoadingOverlay(true);
        if(!this.state.InstrumentID){
            this.ShareholderRef.toggleLoadingOverlay(false);
            return
        }
        let stockID = this.state.InstrumentID.split('').findIndex(i => i !== '0')
        if (stockID > -1) {
            stockID = this.state.InstrumentID.substr(stockID)
        }
        const params = {
            msgType: ACTION_TYPE.SECURITY_COMPANY_INFO,
            symbol: { exchangeID: Converter.mappingWebSocketMarket(this.state.marketID), key: stockID },
            language: utilsFunction.switchToolTipsLanguage(this.props.language, WS_LANG_KEY.EN, WS_LANG_KEY.SC, WS_LANG_KEY.TC)
        }
        this.props.getCompanyInfo(params, res => {
            if (res) {
                const ShareholderData = []
                if (res.shareholderInfo) {
                    for (let i = 0; i < res.shareholderInfo.data.length; i++) {
                        const rowData = {}
                        rowData.d_a_i_s_s = res.shareholderInfo.data[i][0]
                        rowData.l_the_total_equity = this.NumericalTransformation(res.shareholderInfo.data[i][1])
                        rowData.r_the_total_equity = (Math.round(res.shareholderInfo.data[i][1] / res.totalCapital * 10000) / 100.00) + '%'
                        ShareholderData.push(rowData)
                    }
                }
                this.setState({
                    companyInfoData: res,
                    ShareholderData,
                    ExecutivesData: res.directorInfo,
                    foldTips: true,
                }, () => {
                })
            }
        })
        this.ShareholderRef.toggleLoadingOverlay(false)
    }

    getDividends() {
        this.setState({dividenData:null})
        if(! this.state.InstrumentID){
            return
        }
        let stockID = this.state.InstrumentID.split('').findIndex(i => i !== '0')
        if (stockID > -1) {
            stockID = this.state.InstrumentID.substr(stockID)
        }
        const params = {
            msgType: ACTION_TYPE.SECURITY_DIVIDEND_RECORD,
            symbol: { exchangeID: Converter.mappingWebSocketMarket(this.state.marketID), key: stockID },
            language: utilsFunction.switchToolTipsLanguage(this.props.language, WS_LANG_KEY.EN, WS_LANG_KEY.SC, WS_LANG_KEY.TC)
        }
        this.dividendRef.toggleLoadingOverlay(true);
        this.props.getDividendRecord(params, res => {
            if (res.dividendRecord) {
                let dividenData = []
                let header = res.dividendRecord.header
                let data = res.dividendRecord.data
                for ( var i = 0 ; i < data.length; i++) {
                    let arr = {}
                    for (var j = 0; j < header.length; j++) {
                        if(header[j] == 'announceDate') continue
                        arr = Object.assign(arr, { [header[j]]: (data[i])[j] })
                    }
                    dividenData.push(arr)
                }
                this.setState({ dividendData: dividenData},()=>{
                })
            } else {
                this.setState({ dividendData: []},)
            }
        })
        this.dividendRef.toggleLoadingOverlay(false);

    }

}
Summary.defaultProps = {
    autoSize: true
}

export default connect(
    state => ({
        language: state.app.language,
        marketParams: state.trade.marketParams,
    }),
    dispatch => ({
        getFinancial: (p, c) => stockActions.getFinancialAction(p, c),
        getCompanyInfo: (p, c) => stockActions.getCompanyInfoAction(p, c),
        getDividendRecord: (p, c) => stockActions.getDividendRecordAction(p, c)
    })
)(Summary)